<template>
    <div>
        <b-row>
            <b-col>
                <label>
                    Frequency
                    <HelpPopup markdown="Number of hours between auto outbound calls" />
                </label>
                <b-input v-model.number="configuration.contactDelay" type="number" min="0" />
            </b-col>
            <b-col>
                <label>
                    Max Age
                    <HelpPopup markdown="Number of Days after the fill date to stop calling" />
                </label>
                <b-input v-model.number="configuration.fillDateMaxAge" type="number" min="0" />
            </b-col>
            <b-col>
                <label>
                    Twilio Flow
                    <HelpPopup markdown="SID of the Twilio Flow" />
                </label>
                <b-input v-model="configuration.twilioFlow" />
            </b-col>
        </b-row>
    </div>
</template>

<script lang="ts">
import { Component, VModel, Vue } from 'vue-property-decorator';
import { AutoOutboundConfiguration } from "@/models/Configuration";
import HelpPopup from "@/components/HelpPopup.vue";

@Component({
    name: "AutoOutboundField",
    components: { HelpPopup },
})
export default class AutoOutboundField extends Vue {
    @VModel() configuration!: AutoOutboundConfiguration;
}

</script>

<style scoped>
</style>
